import { useEffect, useRef } from 'react';

export function useBarcodeScanner(onScan: (code: string) => void) {
	const bufferRef = useRef('');
	const timeoutRef = useRef<NodeJS.Timeout | null>(null);

	useEffect(() => {
		const handleKeyPress = (e: KeyboardEvent) => {
			if (e.key === 'Enter' || e.key === 'Tab') {
				const code = bufferRef.current.trim();
				if (code.length > 5) {
					console.log(code);

					onScan(code);
				}
				bufferRef.current = '';
				return;
			}

			bufferRef.current += e.key;

			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current);
			}

			timeoutRef.current = setTimeout(() => {
				bufferRef.current = '';
			}, 200);
		};

		document.addEventListener('keypress', handleKeyPress);

		return () => {
			document.removeEventListener('keypress', handleKeyPress);
			if (timeoutRef.current) clearTimeout(timeoutRef.current);
			bufferRef.current = '';
		};
	}, [onScan]);
}
